import { render } from "./ReferralRecordOverlay.vue?vue&type=template&id=0806c184&scoped=true&lang=pug"
import script from "./ReferralRecordOverlay.vue?vue&type=script&lang=js"
export * from "./ReferralRecordOverlay.vue?vue&type=script&lang=js"

import "./ReferralRecordOverlay.vue?vue&type=style&index=0&id=0806c184&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0806c184"]])

export default __exports__